import { useProtectedRoute } from './protected-route.hook'
import type { TProtectedRouteConfig } from './protected-route.types'

export const ProtectedRoute = ({ children, fallback = null }: TProtectedRouteConfig) => {
  const { isLoading, isAuthenticated } = useProtectedRoute()

  if (isLoading || !isAuthenticated) {
    return <>{fallback}</>
  }

  return <>{children}</>
}

ProtectedRoute.displayName = 'ProtectedRoute'
